module.exports = __webpack_public_path__ + "img/copper.83e26574.png";